


















































import { defineComponent, ref } from '@vue/composition-api';
import BankingAccountsHandler from '../../components/banking/BankingAccounts.handler.vue';
import BasePage from '../../components/base/BasePage.vue';
import { HeroBanner, WarningBanner } from '../../components/base/banners';
import { BankingPageInformation } from '../../components/utils/useCustomerPageInformation.hooks';
import ASecondaryBtn from '../../components/base/app/buttons/ASecondaryBtn.vue';
import CtaBanner from '../../components/base/banners/CtaBanner.vue';
import { MIGRATION } from '@ligo/dashboard/customer/store';

export default defineComponent({
  name: 'BankingLanding',
  components: {
    CtaBanner,
    BankingAccountsHandler,
    BasePage,
    HeroBanner,
    WarningBanner,
    ASecondaryBtn
  },
  props: {
    successAccountCreated: Boolean
  },
  setup(props) {
    const infoBanner = ref(false);
    const warningBanner = ref(false);
    const { t, isReady, load } = BankingPageInformation;
    load();

    const openBanking = () => {
      window.open(MIGRATION.BANKING, '_blank');
    };

    if (props.successAccountCreated) {
      infoBanner.value = true;
      warningBanner.value = true;
    }

    return { infoBanner, warningBanner, t, isReady, openBanking };
  }
});
